import { c as _c } from "react/compiler-runtime";
import { Tab, TabGroup, TabList } from '@headlessui/react';
import { NewsletterSplitTestViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface';
import Router, { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import { CheckCircleIcon } from '@systemeio/ui/icons';
interface VariantsTabsProps {
  splitTestData: NewsletterSplitTestViewApiInterface['mailingSplitTest'];
  variantAHasError: boolean;
  variantBHasError: boolean;
}
export function VariantsTabs(t0) {
  const $ = _c(23);
  const {
    splitTestData,
    variantAHasError,
    variantBHasError
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    query,
    replace
  } = useRouter();
  const selectedVariant = query.variant ? Number(query.variant) : undefined;
  let t1;
  let t2;
  if ($[0] !== query || $[1] !== selectedVariant || $[2] !== splitTestData.mailingVariantA.id) {
    t1 = () => {
      if (!selectedVariant) {
        Router.replace({
          query: {
            ...query,
            variant: splitTestData.mailingVariantA.id
          }
        }, undefined, {
          scroll: false
        });
      }
    };
    t2 = [query, selectedVariant, splitTestData.mailingVariantA.id];
    $[0] = query;
    $[1] = selectedVariant;
    $[2] = splitTestData.mailingVariantA.id;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== query || $[6] !== replace || $[7] !== selectedVariant || $[8] !== splitTestData.mailingWinnerSourceId) {
    t3 = (id, title, hasErrors) => {
      const isWinner = splitTestData.mailingWinnerSourceId === id;
      return <Tab className={twMerge(selectedVariant === id && "text-brand-primary bg-text-secondary/10", "flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-1 text-base outline-hidden lg:flex-auto", hasErrors && "text-danger")} onClick={() => replace({
        query: {
          ...query,
          variant: id
        }
      }, undefined, {
        scroll: false
      })}>{isWinner && <CheckCircleIcon className="fill-green h-[16px] w-[16px] sm:h-[20px] sm:w-[20px]" />}{title}</Tab>;
    };
    $[5] = query;
    $[6] = replace;
    $[7] = selectedVariant;
    $[8] = splitTestData.mailingWinnerSourceId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const getTab = t3;
  let t4;
  if ($[10] !== getTab || $[11] !== splitTestData.mailingVariantA.id || $[12] !== t || $[13] !== variantAHasError) {
    t4 = getTab(splitTestData.mailingVariantA.id, t("dashboard.newsletter_editor.split_test.variant_a"), variantAHasError);
    $[10] = getTab;
    $[11] = splitTestData.mailingVariantA.id;
    $[12] = t;
    $[13] = variantAHasError;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== getTab || $[16] !== splitTestData.mailingVariantB.id || $[17] !== t || $[18] !== variantBHasError) {
    t5 = getTab(splitTestData.mailingVariantB.id, t("dashboard.newsletter_editor.split_test.variant_b"), variantBHasError);
    $[15] = getTab;
    $[16] = splitTestData.mailingVariantB.id;
    $[17] = t;
    $[18] = variantBHasError;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <TabGroup><TabList className="bg-background-secondary flex w-full gap-1 rounded-t-md p-1 lg:w-fit">{t4}{t5}</TabList></TabGroup>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}